// Hook returning a callable API client bound to the current Cognito access
// token. Re-evaluates whenever the user changes (sign-in, refresh).

import { useAuth } from "react-oidc-context";
import { useCallback } from "react";
import { ApiError, apiFetch } from "./api";

export function useApi() {
  const auth = useAuth();
  const token = auth.user?.access_token;

  const call = useCallback(
    <T,>(path: string, init?: RequestInit): Promise<T> => {
      if (!token) {
        return Promise.reject(new ApiError(401, "Not signed in"));
      }
      return apiFetch<T>(token, path, init);
    },
    [token]
  );

  return { call, hasToken: Boolean(token) };
}
